module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@3x-d3bbd2213f7e4ad4f3223ab113336570.png";